import clsx from 'clsx';

import { BADGE_SHAPE } from './badgeVariants';

// -----------------------------------------------------------------------------
// Компонент Badge
// -----------------------------------------------------------------------------
//
// Импорт:
//   import { Badge, BADGE_VARIANT, BADGE_SHAPE } from '@shared/ui/badge';
//
// Пропсы:
//   label      {string}             опционально — текст бейджа; без него рендерится только иконка
//   variant    {string}             опционально — один из BADGE_VARIANT
//   shape      {string}             опционально — один из BADGE_SHAPE (по умолчанию: BADGE_SHAPE.base)
//   iconLeft   {React.ElementType}  опционально — ведущая иконка слева (16px)
//   iconRight  {React.ElementType}  опционально — замыкающая иконка справа (14px)
//   className  {string}             опционально — дополнительный класс на корневом элементе
//
// Форма (BADGE_SHAPE):
//   base   — прямоугольный, border-radius 4px,   типографика: body-medium-sm
//   pill   — скруглённый,   border-radius 200px,  типографика: semantic-badge
//   pillSm — скруглённый маленький (только soft | info), типографика: body-medium-xs
//
// Варианты (BADGE_VARIANT):
//   soft-   — цветной фон + цветная рамка + цветной текст
//   info-   — нейтральный фон + цветная рамка + цветной текст
//   solid-  — насыщенный фон + белый текст
//   disable — задизейбленный стиль
//   Цвета: blue | gray | green | orange | red | violet | lime
//
// Примеры:
//
//   // 1. Только текст
//   <Badge label='Активен' variant={BADGE_VARIANT.softGreen} />
//
//   // 2. Иконка слева
//   <Badge label='Активен' variant={BADGE_VARIANT.softGreen} iconLeft={CheckIcon} />
//
//   // 3. Иконка справа
//   <Badge label='Удалить' variant={BADGE_VARIANT.softRed} iconRight={CloseIcon} />
//
//   // 4. Обе иконки
//   <Badge label='Лейбл' variant={BADGE_VARIANT.softBlue} iconLeft={StarIcon} iconRight={CloseIcon} />
//
//   // 5. Форма pill
//   <Badge label='Новый' variant={BADGE_VARIANT.solidBlue} shape={BADGE_SHAPE.pill} />
//
//   // 6. Форма pill-sm (иконки опциональны)
//   <Badge label='Черновик' variant={BADGE_VARIANT.infoGray} shape={BADGE_SHAPE.pillSm} />
//
//   // 7. Только иконка (без текста)
//   <Badge variant={BADGE_VARIANT.softBlue} iconLeft={StarIcon} />
//
// -----------------------------------------------------------------------------

const TEXT_CLASS = {
	[BADGE_SHAPE.base]:   'body-medium-sm',
	[BADGE_SHAPE.pill]:   'semantic-badge',
	[BADGE_SHAPE.pillSm]: 'body-medium-xs',
};

export const Badge = ({
	label,
	variant,
	shape = BADGE_SHAPE.base,
	iconLeft: IconLeft,
	iconRight: IconRight,
	className,
}) => {
	const textClass = TEXT_CLASS[shape] ?? 'semantic-badge';

	return (
		<span className={clsx('badge', shape, variant, className)}>
			{IconLeft && (
				<IconLeft
					className='badge__icon-left'
					aria-hidden='true'
					focusable='false'
				/>
			)}
			{label && <span className={textClass}>{label}</span>}
			{IconRight && (
				<IconRight
					className='badge__icon-right'
					aria-hidden='true'
					focusable='false'
				/>
			)}
		</span>
	);
};
